module.exports = __webpack_public_path__ + "static/media/ikea-ps-2017-vases-recycled-grass.f3bf2acf.jpg";